import { isIE11 } from './isIE11';

export default function getScrollY() {
  return isIE11 ? window.pageYOffset : window.scrollY;
}
